<template>
  <footer id="gocontact">
    <div class="container">
      <div class="footer">
        <img :src="logo" alt="" />
        <ul class="user-ul hide-m">
          <li><router-link to="/">{{ $t('pageFooter.home') }}</router-link></li>
          <li><a href="#gomain">{{ $t('pageFooter.aboutUs') }}</a></li>
          <li><a href="#gospecial">{{ $t('pageFooter.ourFeatures') }}</a></li>
          <li><a href="#gocontact">{{ $t('pageFooter.contactUs') }}</a></li>
        </ul>
        <ul class="socials">
          <li v-for="social in socials" :key="social.id">
            <a target="_blank" :href="social.link"
              ><img :src="social.icon" alt="social.name"
            /></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";

// reactive state
const loader = ref(false);
const logo = ref("");
const socials = ref([]);

// functions
function getContact() {
  loader.value = true;
  axios.get("/socials").then((response) => {
    logo.value = response.data.data.logo;
    socials.value = response.data.data.socials;
    loader.value = false;
  });
}

// mounted
onMounted(() => {
  getContact();
});
</script>

<style></style>
